module.exports = __webpack_public_path__ + "img/home.bdcab42e.svg";